(function ($) {
    function sizeAccents($scope) {
        // This selector includes both photo accents and the no-photo fluid variant.
        $scope.find(".c-employee-profile-repeater-block__bg-image--angle").each(function () {
            const $accent = $(this);
            const height = $accent.height();

            // Hidden mobile accents are measured again when the viewport changes.
            if (height > 0) {
                $accent.css("width", height + "px");
            }
        });
    }

    function sizeAllAccents() {
        sizeAccents($(document));
    }

    $(function () {
        sizeAllAccents();
        $(window).on("load.employeeProfileRepeater resize.employeeProfileRepeater", sizeAllAccents);

        if (window.acf) {
            window.acf.addAction("render_block_preview/type=employee-profile-repeater", function ($block) {
                sizeAccents($block);
                $block.find("img").on("load.employeeProfileRepeater", function () {
                    sizeAccents($block);
                });
            });
        }
    });
})(jQuery);
